module.exports = __webpack_public_path__ + "img/FK.b42ad823.svg";